var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    { staticClass: "desktop-header" },
    [
      _c("Logo", { staticClass: "desktop-header__logo" }),
      _c("nav", { staticClass: "desktop-header__settings" }, [
        _c("div", { staticClass: "desktop-header__view" }, [
          _c("span", { staticClass: "desktop-header__label" }, [
            _vm._v(_vm._s(_vm.$t("View")) + " :"),
          ]),
          _c(
            "button",
            {
              staticClass: "desktop-header__view-btn",
              class: { active: _vm.shownViewMode === 1 },
              attrs: {
                type: "button",
                "aria-pressed": String(_vm.shownViewMode === 1),
                "aria-label": _vm.$t("Single pane"),
              },
              on: {
                click: function ($event) {
                  return _vm.setViewMode(1)
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src:
                    _vm.shownViewMode === 1
                      ? _vm.icons.oneActive
                      : _vm.icons.one,
                  alt: "",
                },
              }),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "desktop-header__view-btn",
              class: { active: _vm.shownViewMode === 2 },
              attrs: {
                type: "button",
                "aria-pressed": String(_vm.shownViewMode === 2),
                "aria-label": _vm.$t("Split view"),
                disabled: _vm.singleOnly,
              },
              on: {
                click: function ($event) {
                  return _vm.setViewMode(2)
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src:
                    _vm.shownViewMode === 2
                      ? _vm.icons.twoActive
                      : _vm.icons.two,
                  alt: "",
                },
              }),
            ]
          ),
        ]),
        _c("div", { staticClass: "desktop-header__max" }, [
          _c("span", { staticClass: "desktop-header__label" }, [
            _vm._v(_vm._s(_vm.$t("Max")) + " :"),
          ]),
          _c("span", { staticClass: "desktop-header__value" }, [
            _vm._v(
              _vm._s(_vm.formatAmountWithKM(_vm.mainLimitAmountPerFight, 0))
            ),
          ]),
          _c("div", { staticClass: "drop-down disable" }, [
            _c("div", { staticClass: "drop-down-item" }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/svg/chart-icons/banker.svg"),
                  alt: "Banker",
                },
              }),
              _c("img", {
                attrs: {
                  src: require("@/assets/svg/chart-icons/player.svg"),
                  alt: "Player",
                },
              }),
              _c("span", { staticClass: "limit-text" }, [
                _vm._v(
                  _vm._s(_vm.formatAmountWithKM(_vm.mainLimitAmountPerFight, 0))
                ),
              ]),
            ]),
            _c("div", { staticClass: "drop-down-item" }, [
              _c("img", {
                staticClass: "draw-icon",
                attrs: {
                  src: require("@/assets/svg/chart-icons/draw.svg"),
                  alt: "Draw",
                },
              }),
              _c("span", { staticClass: "limit-text" }, [
                _vm._v(
                  _vm._s(_vm.formatAmountWithKM(_vm.drawLimitAmountPerFight, 0))
                ),
              ]),
            ]),
          ]),
        ]),
        _c("span", { staticClass: "desktop-header__separator" }),
        _vm.lobbyUrl
          ? _c(
              "button",
              {
                staticClass: "desktop-header__link",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.redirectToLobby()
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("Lobby")) + " ")]
            )
          : _vm._e(),
        _c(
          "button",
          {
            staticClass: "desktop-header__link desktop-header__link--help",
            class: { active: _vm.activePopupPage === _vm.PopupPage.help },
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.openMenuPopup(_vm.PopupPage.help)
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.$t("Game help")) + " ")]
        ),
        _c(
          "div",
          { staticClass: "desktop-header__lang" },
          [_c("LanguageDropdown")],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "desktop-header__ticker" },
        [_vm._t("ticker")],
        2
      ),
      _c(
        "div",
        {
          staticClass: "desktop-header__user",
          class: { "desktop-header__user--menu": _vm.withCommission },
        },
        [
          _c("img", {
            staticClass: "desktop-header__avatar",
            attrs: { src: require("@/assets/svg/profile-icon.svg"), alt: "" },
          }),
          _c("span", { staticClass: "desktop-header__name" }, [
            _vm._v(_vm._s(_vm.memberName)),
          ]),
          _c(
            "div",
            { staticClass: "drop-down" },
            [
              _vm.config.availableOddsType.length > 1
                ? _c("ToggleBtn", {
                    staticClass: "drop-down-item",
                    attrs: {
                      leftTxt: _vm.$t("Eu"),
                      rightTxt: _vm.$t("My"),
                      value: _vm.toggleValue,
                    },
                    on: { toggle: (e) => _vm.toggleOdds(e) },
                  })
                : _vm._e(),
              _vm.withCommission
                ? _c(
                    "div",
                    {
                      staticClass: "drop-down-item",
                      on: {
                        click: function ($event) {
                          return _vm.logoutCreditUser()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Logout")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "desktop-header__wallet" },
        [
          _c(
            "div",
            {
              staticClass: "desktop-header__balance",
              class: { "tooltip-container": _vm.isLargeBalance },
            },
            [
              _vm._v(" " + _vm._s(_vm.currencySymbol) + " "),
              _c("animated-amount", {
                attrs: {
                  value: _vm.balance,
                  formatValue: _vm.isLargeBalance
                    ? _vm.formatLargeAmount
                    : _vm.formatAmount,
                  duration: 500,
                },
              }),
              _vm.isLargeBalance
                ? _c(
                    "span",
                    { staticClass: "desktop-header__balance-tooltip" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("Balance")) +
                          ": " +
                          _vm._s(_vm.currencySymbol) +
                          _vm._s(_vm.formatAmount(_vm.balance)) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("Transition", { attrs: { name: "fade" } }, [
            _vm.futureDiff
              ? _c("div", { staticClass: "desktop-header__diff" }, [
                  _vm._v("+ " + _vm._s(_vm.userFutureDiff)),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }